(function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  function initHover() {
    document.querySelectorAll('header-menu details').forEach((details) => {
      if (details.dataset.hoverInit) return;
      details.dataset.hoverInit = 'true';
      let closeTimer;
      details.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHover);
  } else {
    initHover();
  }
})();
